/**
 * Provides substitutions for commonly used words that are different based on context (MF vs 529).
 */
import { upperFirst } from 'lodash';
import {
  isCollegeAnything,
  isCollegeExchange,
  isExchange,
} from './transactions-util';
import { toLookup } from './utils';
import { isProductType529 } from './funds/funds-utility';

const collegeWords = {
  fund: 'portfolio',
  funds: 'portfolios',
  investment: 'portfolio',
  investments: 'portfolios',
  redeem: 'distribute',
  redeemed: isCollegeExchange() ? 'exchanged' : 'distributed',
  redeeming: 'distributing',
  redemption: isCollegeExchange() ? 'exchange' : 'distribution',
  sell: isCollegeExchange() ? 'exchange' : 'distribute',
  share: 'unit',
  shares: 'units',
};

Object.entries(collegeWords).forEach(
  ([mf, college]) => (collegeWords[upperFirst(mf)] = upperFirst(college))
);

const mutualFundWords = toLookup(Object.keys(collegeWords));

const exchangeWords = {
  ...mutualFundWords,
  sell: 'exchange',
};

/**
 * @typedef {object} Words
 * @property {string} fund
 * @property {string} funds
 * @property {string} redeem
 * @property {string} redemption
 * @property {string} redeeming
 * @property {string} sell
 * @property {string} share
 * @property {string} shares
 *
 * @property {string} Fund
 * @property {string} Funds
 * @property {string} Redeem
 * @property {string} Redeeming
 * @property {string} Redemption
 * @property {string} Sell
 * @property {string} Share
 * @property {string} Shares
 */
/**
 * @type {Words}
 */
export default isCollegeAnything()
  ? collegeWords
  : isExchange()
  ? exchangeWords
  : mutualFundWords;

/**
 *
 * @param {Fund} fund
 * @returns {Words}
 */
export function getWordsForFund(fund) {
  const { productType } = fund;
  return isProductType529(productType) ? collegeWords : mutualFundWords;
}
